import 'twin.macro'
import React from 'react'
import { trim, each, size } from 'lodash'

import { useListenUserProfileQuery } from 'modules/Users/userApi'
import { useAuth } from 'modules/Auth/hooks/useAuth'
import { useListenCoachVideosQuery } from 'modules/VideoLibrary/videoLibraryApi'

import { Button } from 'common/components/Button/Button'
import { Spinner } from 'common/components/Spinner/Spinner'
import { isVideoReady, VIDEO_PROCESSING_LABEL } from 'common/utils/videoUtils'
import { availableItemTypes } from '../constants/constants'
import { selectButtonActiveStyles, selectButtonBaseStyles } from '../styles'
import { getItemExists, includesSearchQuery } from '../utils'

export function VideoSelection({ existingItems, currentItem, handleSelection, searchQuery }) {
  const { userId } = useAuth()
  const { data: profile } = useListenUserProfileQuery({ userId })
  const coachOrgId = profile?.coachOrgId || ''

  const { data: videoData } = useListenCoachVideosQuery({ coachOrgId })
  const videos = videoData?.isLoading || videoData === null || videoData === undefined ? {} : videoData

  if (videoData?.isLoading) {
    return <div className='text-sm'>Loading...</div>
  }

  if (!videos || size(videos) === 0) {
    return <div className='text-sm'>No videos in your video library.</div>
  }

  const availableVideos = getAvailableVideos()

  if (!Object.keys(availableVideos).length) {
    return (
      <div className='text-sm'>{!searchQuery?.length ? 'No video results.' : 'No video results for this search.'}</div>
    )
  }

  // A video whose upload is still processing is listed, so the coach can see it
  // exists, but is greyed out and cannot be chosen.
  return Object.entries(availableVideos).map(([videoId, video]) => {
    const ready = isVideoReady(video)
    return (
      <Button
        key={videoId}
        type='button'
        onClick={() => handleSelection({ id: videoId })}
        variant='secondary'
        size='md'
        disabled={!ready}
        title={ready ? undefined : VIDEO_PROCESSING_LABEL}
        css={[selectButtonBaseStyles, currentItem.id === videoId && selectButtonActiveStyles]}
      >
        <div className='flex-1'>
          <span className='flex'>{trim(video.title) ? video.title : 'Untitled'}</span>
        </div>
        {!ready && (
          <span className='flex items-center text-xs font-medium text-gray-500 ml-3'>
            <Spinner className='w-3 h-3 mr-1 text-gray-100' fillClassName='fill-gray-500' />
            {VIDEO_PROCESSING_LABEL}
          </span>
        )}
      </Button>
    )
  })

  function getAvailableVideos() {
    const availableVideos = {}

    each(videos, (video, videoId) => {
      const includesQuery = includesSearchQuery(video.title, searchQuery)

      const itemExists = getItemExists({
        existingItems,
        itemId: videoId,
        itemType: availableItemTypes.VIDEO,
      })

      if (includesQuery && !itemExists && video.title) {
        availableVideos[videoId] = video
      }
    })

    return availableVideos
  }
}
